import React from 'react';

const Link2: React.FC = () => {
	return <div>Coming Soon...</div>;
};

export default Link2;
